import styled from '@emotion/styled';

export const DropdownSelect = styled.select<{ opened?: boolean }>`
  display: flex;
  align-items: center;
  height: 45px;
  max-width: 340px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 12px;
  border: 2px solid #bdcad2;
  font-size: 16px;
  color: #566072;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='%23fff' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='%234694CE'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat;
  background-position: right top 50%;
  background-size: auto 41px;
  background-color: white;
  appearance: none;

  outline-color: #4694ce;
  outline-width: 0;
  cursor: pointer;
  &:focus,
  &:hover {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 41'%3E%3Cpath fill='%234694CE' d='M0 0h30v41H0z'/%3E%3Cpath d='M11.2 17.8a1 1 0 10-1.4 1.4l1.4-1.4zm3.8 5.7l-.7.7a1 1 0 001.4 0l-.7-.7zm5.2-4.3a1 1 0 10-1.4-1.4l1.4 1.4zm-10.4 0l4.5 5 1.4-1.4-4.5-5-1.4 1.4zm6 5l4.4-5-1.4-1.4-4.5 5 1.4 1.4z' fill='%23ffff'/%3E%3C/svg%3E") !important;
  }
  &:focus {
    border-color: #4694ce;
    background-color: #f5fbff;
  }
  & option:disabled {
    pointer-events: none;
  }
`;
